// Read aloud for the clone sample — warm, first-person, varied rhythm,
// so the cloned voice learns how you sound when you speak to yourself.
export const CLONE_SCRIPT = [
  "Hello. This is my voice, and I'm recording it slowly, calmly, and in my own time.",
  "I am safe in this moment. I breathe in, and I let my shoulders soften. I breathe out, and I let the day settle.",
  "I trust myself. I trust the way I prepare, the way I learn, and the way I come back to centre when things don't go to plan.",
  "Nothing is missing right now. I have everything I need to take the next step, and the step after that.",
  "When the pressure rises, I stay steady. My hands are soft, my mind is quiet, and my focus is clear.",
  "I am proud of how far I've come. I give myself the same kindness I would give to someone I love.",
  "Every day, in small ways, I am becoming the person I know I can be. Calm. Confident. Present.",
  "Thank you for listening. This is me — and this is how I sound when I'm speaking to myself with care.",
];

// Extra lines for the longer 2-minute re-record, so the clone learns more of how you speak.
export const CLONE_SCRIPT_EXTRA = [
  "Some mornings I wake up full of energy. Other mornings I need a moment, a cup of tea, and a little patience with myself.",
  "I remember walking by the sea, the wind in my face, and feeling that everything would be all right.",
  "When I talk to the people I care about, I slow down. I listen. I let them finish, and then I answer from the heart.",
  "I can be playful, too. I laugh easily, I enjoy a good story, and I like to see the people around me smile.",
  "Tonight, as I rest, I let go of the day. Tomorrow I begin again, steady, grateful and ready.",
  "This is my voice. Warm, real and completely my own.",
];

export const MIN_SECONDS = 60;
export const REDO_MIN_SECONDS = 120;
export const MAX_SECONDS = 180;
